import {Reducer} from 'redux';
import {ReportsAction, ReportsActionTypes, ReportsState} from './types';
import {RequestStatus, RequestStatusType, SharedActionTypes} from '../shared/types';

function initialState(): ReportsState {
    return {
        scheduledReports: [],
    };
}

const reducer: Reducer<ReportsState, ReportsAction> = (state = initialState(), action): ReportsState => {
    switch (action.type) {
        case SharedActionTypes.LOGOUT_SUCCESS:
        case SharedActionTypes.UNSELECT_FLEET_CUSTOMER: {
            return initialState();
        }
        case ReportsActionTypes.FETCH_ENHANCED_ACTIVE_FLEET_REPORT_REQUEST: {
            return {...state, enhancedActiveFleetReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_ENHANCED_ACTIVE_FLEET_REPORT_SUCCESS: {
            return {...state, enhancedActiveFleetReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_ENHANCED_ACTIVE_FLEET_REPORT_FAILURE: {
            return {
                ...state,
                enhancedActiveFleetReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_MASTER_FLEET_LIST_REPORT_REQUEST: {
            return {...state, masterFleetListReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_MASTER_FLEET_LIST_REPORT_SUCCESS: {
            return {...state, masterFleetListReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_MASTER_FLEET_LIST_REPORT_FAILURE: {
            return {
                ...state,
                masterFleetListReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_VEHICLE_JOB_LIST_REPORT_REQUEST: {
            return {...state, vehicleJobListReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_VEHICLE_JOB_LIST_REPORT_SUCCESS: {
            return {...state, vehicleJobListReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_VEHICLE_JOB_LIST_REPORT_FAILURE: {
            return {
                ...state,
                vehicleJobListReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_MOUNTED_TIRE_DETAILS_REPORT_REQUEST: {
            return {...state, mountedTireDetailsReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_MOUNTED_TIRE_DETAILS_REPORT_SUCCESS: {
            return {...state, mountedTireDetailsReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_MOUNTED_TIRE_DETAILS_REPORT_FAILURE: {
            return {
                ...state,
                mountedTireDetailsReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_DAMAGED_TIRE_DETAILS_REPORT_REQUEST: {
            return {...state, damagedTireDetailsReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_DAMAGED_TIRE_DETAILS_REPORT_SUCCESS: {
            return {...state, damagedTireDetailsReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_DAMAGED_TIRE_DETAILS_REPORT_FAILURE: {
            return {
                ...state,
                damagedTireDetailsReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_EXTENDED_INSPECTION_REPORT_REQUEST: {
            return {...state, extendedInspectionReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_EXTENDED_INSPECTION_REPORT_SUCCESS: {
            return {...state, extendedInspectionReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_EXTENDED_INSPECTION_REPORT_FAILURE: {
            return {
                ...state,
                extendedInspectionReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_EXTENDED_SERVICE_REPORT_REQUEST: {
            return {
                ...state,
                extendedServiceReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)
            };
        }
        case ReportsActionTypes.FETCH_EXTENDED_SERVICE_REPORT_SUCCESS: {
            return {...state, extendedServiceReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_EXTENDED_SERVICE_REPORT_FAILURE: {
            return {
                ...state,
                extendedServiceReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_VEHICLES_DUE_FOR_INSPECTION_REPORT_REQUEST: {
            return {
                ...state,
                vehiclesDueForInspectionReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)
            };
        }
        case ReportsActionTypes.FETCH_VEHICLES_DUE_FOR_INSPECTION_REPORT_SUCCESS: {
            return {
                ...state,
                vehiclesDueForInspectionReportRequestStatus: new RequestStatus(RequestStatusType.Success),
            };
        }
        case ReportsActionTypes.FETCH_VEHICLES_DUE_FOR_INSPECTION_REPORT_FAILURE: {
            return {
                ...state,
                vehiclesDueForInspectionReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_REMOVED_AND_FITTED_TIRES_REPORT_REQUEST: {
            return {
                ...state,
                removedAndFittedTiresReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)
            };
        }
        case ReportsActionTypes.FETCH_REMOVED_AND_FITTED_TIRES_REPORT_SUCCESS: {
            return {...state, removedAndFittedTiresReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_REMOVED_AND_FITTED_TIRES_REPORT_FAILURE: {
            return {
                ...state,
                removedAndFittedTiresReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_MILEAGE_BILLING_REPORT_REQUEST: {
            return {
                ...state,
                mileageBillingReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)
            };
        }
        case ReportsActionTypes.FETCH_MILEAGE_BILLING_REPORT_SUCCESS: {
            return {...state, mileageBillingReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_MILEAGE_BILLING_REPORT_FAILURE: {
            return {
                ...state,
                mileageBillingReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_BREAKDOWN_AND_SERVICES_BILLING_REPORT_REQUEST: {
            return {
                ...state,
                breakdownAndServicesBillingReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)
            };
        }
        case ReportsActionTypes.FETCH_BREAKDOWN_AND_SERVICES_BILLING_REPORT_SUCCESS: {
            return {...state, breakdownAndServicesBillingReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_BREAKDOWN_AND_SERVICES_BILLING_REPORT_FAILURE: {
            return {
                ...state,
                breakdownAndServicesBillingReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_DAMAGED_TIRES_BILLING_REPORT_REQUEST: {
            return {
                ...state,
                damagedTiresBillingReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)
            };
        }
        case ReportsActionTypes.FETCH_DAMAGED_TIRES_BILLING_REPORT_SUCCESS: {
            return {...state, damagedTiresBillingReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_DAMAGED_TIRES_BILLING_REPORT_FAILURE: {
            return {
                ...state,
                damagedTiresBillingReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_UNMOUNTED_TIRES_REPORT_REQUEST: {
            return {...state, unmountedTiresReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_UNMOUNTED_TIRES_REPORT_SUCCESS: {
            return {...state, unmountedTiresReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_UNMOUNTED_TIRES_REPORT_FAILURE: {
            return {
                ...state,
                unmountedTiresReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_UNBILLED_JOBS_REPORT_REQUEST: {
            return {...state, unbilledJobsRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_UNBILLED_JOBS_REPORT_SUCCESS: {
            return {...state, unbilledJobsRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_UNBILLED_JOBS_REPORT_FAILURE: {
            return {
                ...state,
                unbilledJobsRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_TIRE_PERFORMANCE_REPORT_REQUEST: {
            return {...state, tirePerformanceRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_TIRE_PERFORMANCE_REPORT_SUCCESS: {
            return {...state, tirePerformanceRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_TIRE_PERFORMANCE_REPORT_FAILURE: {
            return {
                ...state,
                tirePerformanceRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_TIRE_PERFORMANCE_OPTIONS_REQUEST: {
            return {...state, tirePerformanceOptionsRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_TIRE_PERFORMANCE_OPTIONS_SUCCESS: {
            return {
                ...state,
                tirePerformanceOptions: action.payload,
                tirePerformanceOptionsRequestStatus: new RequestStatus(RequestStatusType.Success)
            };
        }
        case ReportsActionTypes.FETCH_TIRE_PERFORMANCE_OPTIONS_FAILURE: {
            return {
                ...state,
                tirePerformanceOptionsRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_TIRE_STOCK_REPORT_REQUEST: {
            return {...state, tireStockReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_TIRE_STOCK_REPORT_SUCCESS: {
            return {...state, tireStockReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_TIRE_STOCK_REPORT_FAILURE: {
            return {
                ...state,
                tireStockReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_TIRE_STOCK_COMPANIES_REQUEST: {
            return {...state, tireStockCompaniesRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_TIRE_STOCK_COMPANIES_SUCCESS: {
            return {
                ...state,
                tireStockCompanies: action.payload,
                tireStockCompaniesRequestStatus: new RequestStatus(RequestStatusType.Success)
            };
        }
        case ReportsActionTypes.FETCH_TIRE_STOCK_COMPANIES_FAILURE: {
            return {
                ...state,
                tireStockCompaniesRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_TIRE_HISTORY_REPORT_REQUEST: {
            return {...state, tireHistoryReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_TIRE_HISTORY_REPORT_SUCCESS: {
            return {...state, tireHistoryReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_TIRE_HISTORY_REPORT_FAILURE: {
            return {
                ...state,
                tireHistoryReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_VEHICLES_CURRENT_STATUS_REPORT_REQUEST: {
            return {...state, vehiclesCurrentStatusRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_VEHICLES_CURRENT_STATUS_REPORT_SUCCESS: {
            return {...state, vehiclesCurrentStatusRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_VEHICLES_CURRENT_STATUS_REPORT_FAILURE: {
            return {
                ...state,
                vehiclesCurrentStatusRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_INVOICE_BY_JOB_REPORT_REQUEST: {
            return {...state, invoiceByJobRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_INVOICE_BY_JOB_REPORT_SUCCESS: {
            return {...state, invoiceByJobRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_INVOICE_BY_JOB_REPORT_FAILURE: {
            return {
                ...state,
                invoiceByJobRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_INVOICE_BY_VEHICLE_REPORT_REQUEST: {
            return {...state, invoiceByVehicleRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_INVOICE_BY_VEHICLE_REPORT_SUCCESS: {
            return {...state, invoiceByVehicleRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_INVOICE_BY_VEHICLE_REPORT_FAILURE: {
            return {
                ...state,
                invoiceByVehicleRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_INVOICE_ITEM_BY_VEHICLE_REPORT_REQUEST: {
            return {...state, invoiceItemByVehicleRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_INVOICE_ITEM_BY_VEHICLE_REPORT_SUCCESS: {
            return {...state, invoiceItemByVehicleRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_INVOICE_ITEM_BY_VEHICLE_REPORT_FAILURE: {
            return {
                ...state,
                invoiceItemByVehicleRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_ENHANCED_INVOICE_ITEM_BY_VEHICLE_REPORT_REQUEST: {
            return {...state, enhancedInvoiceItemByVehicleRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_ENHANCED_INVOICE_ITEM_BY_VEHICLE_REPORT_SUCCESS: {
            return {...state, enhancedInvoiceItemByVehicleRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_ENHANCED_INVOICE_ITEM_BY_VEHICLE_REPORT_FAILURE: {
            return {
                ...state,
                enhancedInvoiceItemByVehicleRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_BREAKDOWN_LIST_REPORT_REQUEST: {
            return {...state, breakdownListRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_BREAKDOWN_LIST_REPORT_SUCCESS: {
            return {...state, breakdownListRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_BREAKDOWN_LIST_REPORT_FAILURE: {
            return {
                ...state,
                breakdownListRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_INSPECTION_DETAILS_REPORT_REQUEST: {
            return {...state, inspectionDetailsRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_INSPECTION_DETAILS_REPORT_SUCCESS: {
            return {...state, inspectionDetailsRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_INSPECTION_DETAILS_REPORT_FAILURE: {
            return {
                ...state,
                inspectionDetailsRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_TCU_SENSOR_FITMENTS_REPORT_REQUEST: {
            return {...state, tcuSensorFitmentsRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_TCU_SENSOR_FITMENTS_REPORT_SUCCESS: {
            return {...state, tcuSensorFitmentsRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_TCU_SENSOR_FITMENTS_REPORT_FAILURE: {
            return {
                ...state,
                tcuSensorFitmentsRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_JOB_VERIFICATION_REPORT_REQUEST: {
            return {...state, jobVerificationRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_JOB_VERIFICATION_REPORT_SUCCESS: {
            return {...state, jobVerificationRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_JOB_VERIFICATION_REPORT_FAILURE: {
            return {
                ...state,
                jobVerificationRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_ODOMETER_LIST_REPORT_REQUEST: {
            return {...state, odometerListRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_ODOMETER_LIST_REPORT_SUCCESS: {
            return {...state, odometerListRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_ODOMETER_LIST_REPORT_FAILURE: {
            return {
                ...state,
                odometerListRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)
            };
        }
        case ReportsActionTypes.FETCH_SCHEDULED_REPORTS_REQUEST: {
            return {...state, getScheduledReportsRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_SCHEDULED_REPORTS_SUCCESS: {
            return {...state, scheduledReports: action.payload, getScheduledReportsRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_SCHEDULED_REPORTS_FAILURE: {
            return {...state, getScheduledReportsRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)};
        }
        case ReportsActionTypes.CREATE_SCHEDULED_REPORT_REQUEST: {
            return {...state, createScheduledReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.CREATE_SCHEDULED_REPORT_SUCCESS: {
            const scheduledReports = [...state.scheduledReports];
            scheduledReports.push(action.payload);
            return {...state, createScheduledReportRequestStatus: new RequestStatus(RequestStatusType.Success), scheduledReports };
        }
        case ReportsActionTypes.CREATE_SCHEDULED_REPORT_FAILURE: {
            return {...state, createScheduledReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)};
        }
        case ReportsActionTypes.UPDATE_SCHEDULED_REPORT_REQUEST: {
            return {...state, updateScheduledReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.UPDATE_SCHEDULED_REPORT_SUCCESS: {
            const scheduledReports = [...state.scheduledReports];
            const reportToReplace = scheduledReports.find(report => report.id === action.payload.id);
            const index = scheduledReports.indexOf(reportToReplace!);
            scheduledReports[index] = action.payload;
            return {...state, updateScheduledReportRequestStatus: new RequestStatus(RequestStatusType.Success), scheduledReports };
        }
        case ReportsActionTypes.UPDATE_SCHEDULED_REPORT_FAILURE: {
            return {...state, updateScheduledReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)};
        }
        case ReportsActionTypes.DELETE_SCHEDULED_REPORT_REQUEST: {
            return {...state, deleteScheduledReportRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.DELETE_SCHEDULED_REPORT_SUCCESS: {
            const scheduledReports = state.scheduledReports.filter(report => report.id !== action.payload);
            return {...state, scheduledReports, deleteScheduledReportRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.DELETE_SCHEDULED_REPORT_FAILURE: {
            return {...state, deleteScheduledReportRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)};
        }
        case ReportsActionTypes.FETCH_REPORT_INFO_REQUEST: {
            return {...state, reportInfoRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_REPORT_INFO_SUCCESS: {
            return {...state, reportInfoRequestStatus: new RequestStatus(RequestStatusType.Success), reportInfo: action.payload};
        }
        case ReportsActionTypes.FETCH_REPORT_INFO_FAILURE: {
            return {...state, reportInfoRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)};
        }
        case ReportsActionTypes.FETCH_REPORT_DOWNLOAD_REQUEST: {
            return {...state, reportDownloadRequestStatus: new RequestStatus(RequestStatusType.InProgress)};
        }
        case ReportsActionTypes.FETCH_REPORT_DOWNLOAD_SUCCESS: {
            return {...state, reportDownloadRequestStatus: new RequestStatus(RequestStatusType.Success)};
        }
        case ReportsActionTypes.FETCH_REPORT_DOWNLOAD_FAILURE: {
            return {...state, reportDownloadRequestStatus: new RequestStatus(RequestStatusType.Failed, action.payload)};
        }

        default: {
            return state;
        }
    }
};

export {reducer as reportsReducer};
export {initialState as initialReportsState};
